import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { DocumentType } from './document-type.interface';
import { DocumentTypeService } from './document-type.service';

const service = new DocumentTypeService();

export interface DocumentTypeState {
   documentTypes: Array<DocumentType>;
}

const DocumentTypeStore: Module<DocumentTypeState, StoreState> = {
   namespaced: true,
   state: {
      documentTypes: [],
   },
   getters: {},
   mutations: {
      SET_DOCUMENT_TYPES(state, documentTypes: Array<DocumentType>) {
         state.documentTypes = documentTypes;
      },
   },
   actions: {
      async getDocumentTypes(context, query?: LocationQuery) {
         const response = await service.getDocumentTypes({ ...query, per_page: '100', page: '1' });
         context.commit('SET_DOCUMENT_TYPES', response.data);
         return response.data;
      },
   },
};

export default DocumentTypeStore;
